const initials = "publicData";
export const UPDATE_PUBLIC_DATA = `${initials}UPDATE_PUBLIC_DATA`;